export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A2E24] text-[#FDFBF7]/80 pt-20 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 pb-16 border-b border-[#FDFBF7]/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-12 h-12 rounded-full bg-white overflow-hidden flex items-center justify-center">
                <img
                  src="https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/883uiflg_image.png"
                  alt="Hastkesar Panjrapole logo"
                  className="w-full h-full object-contain p-0.5"
                />
              </span>
              <div>
                <div className="font-display text-[#FDFBF7] text-lg">Hastkesar Panjrapole</div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]">
                  Bokadia Family
                </div>
              </div>
            </div>
            <p className="mt-6 leading-relaxed max-w-md">
              A home, an animal hospital, and a promise — to shelter every
              life that comes to our gate, without conditions.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37] mb-5">Explore</div>
            <ul className="space-y-3 text-sm">
              <li><a href="#about" className="hover:text-[#D4AF37]">About</a></li>
              <li><a href="#services" className="hover:text-[#D4AF37]">Services</a></li>
              <li><a href="#gallery" className="hover:text-[#D4AF37]">Gallery</a></li>
              <li><a href="#stories" className="hover:text-[#D4AF37]">Stories</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37] mb-5">Support & Reach</div>
            <ul className="space-y-3 text-sm">
              <li><a href="#volunteer" className="hover:text-[#D4AF37]">Volunteer</a></li>
              <li><a href="#contact" className="hover:text-[#D4AF37]">Contact</a></li>
              <li className="break-all">hastkesarpanjrapole@gmail.com</li>
              <li>+91 81416 46161</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#FDFBF7]/50">
          <div>© {new Date().getFullYear()} Hastkesar Panjrapole · Run with love by the Bokadia Family.</div>
          <div className="flex items-center gap-6">
            <span>Made with compassion, in India.</span>
            <a
              href="/admin"
              data-testid="footer-admin-login"
              className="inline-flex items-center gap-1.5 text-[#FDFBF7]/60 hover:text-[#D4AF37] tracking-[0.18em] uppercase text-[10px] transition-colors"
            >
              <span className="w-1 h-1 rounded-full bg-[#D4AF37]" />
              Caretaker Login
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
